<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ywu4ic/images/Cover.jpg?1693228932302" alt="This image is the cover for the book Alice Never After #1, Alice Never After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alice Never After #1, Alice Never After
      </h1>
      <p class="bookDescription body article font2">
        <p>Alice finally got her wish. Wonderland has become her new home, but with her abuser’s avatar with the uncanny grin turning the mad residents of a moonstruck world against her, she’s clawing for a little rationality amongst the chaos. As Alice’s sister Edith and her childhood friend Earl fight for a way to bring her back, Alice has to contend with whether or not her torment is due to her father, herself, or maybe a curious combination of both… Superstar writer Dan Panosian (Unkindness of Ravens, Black Tape) and artist Giorgio Spalletta (007: For King&amp; Country) explore the morbid side of escapism in this twisted tale that blurs the line between fantasy and reality.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan Panosian, Giorgio Spalletta
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ff55041